



























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import Editor from '../../../Editor/Editor.vue'
import TextareaCounter from '../../../TextareaCounter/TextareaCounter.vue'
import { MessageEditorComponentSettings, MessageEditorWithMediaTab } from "../../types";
import { FileType } from '../Media/types'
import MessageBodyTabs from './Tabs/MessageBodyTabs.vue'
import MessageSettings from './components/MessageSettings/MessageSettings.vue'
import Topics from './components/Topics/Topics.vue'
import SettingsMessageManager from './logic/SettingsMessageManager'

@Component({
  components: {
    TextareaCounter,
    Topics,
    MessageBodyTabs,
    Editor,
    MessageSettings,
  },
  data() {
    return {
      MessageEditorWithMediaTab,
      FileType,
    }
  }
})
export default class MessageBody extends Vue {
  @Prop() settingsMessageManager!: SettingsMessageManager

  @Prop({ type: Object }) topicsOptions?: MessageEditorComponentSettings['topics']

  @Prop() options!: MessageEditorComponentSettings['options']

  @Prop() readonly availableTabs!: MessageEditorComponentSettings['availableTabs']

  @Prop() readonly counterMax!: MessageEditorComponentSettings['counterMax']

  @Prop() placeholders?: MessageEditorComponentSettings['placeholders']

  @Prop() disabled!: MessageEditorComponentSettings['disabled']

  @Prop() moreThanOneAttachment!: boolean

  @Prop() buttonsExist!: boolean

  @Prop() settingsStructure!: MessageEditorComponentSettings['settingsStructure']

  disabledPanelElements = []

  currentTab: MessageEditorWithMediaTab = MessageEditorWithMediaTab.EditorTab

  get messageText(): string {
    return this.settingsMessageManager.fields.text
  }

  set messageText(val: string) {
    this.settingsMessageManager.setFieldValue('text', val)
  }
}
